//reporte de actividad de clientes
import React, { Component, Fragment } from 'react';
import Sidebar from '../navigation/Sidebar';
import { withRouter } from "react-router-dom";
import Rest from "../../services/Rest";
import Can from "../../config/Can";

const initialState = {
    camps: [],
    reportHidden: "hidden",
    error: false,
    errorMessage: "",
    id_campana: "",
    fechaInicio: "",
    fechaFin: "",
    reporte: null

}

class CampaingBalance extends Component {

    constructor(props) {
        super(props)
        this.Can = new Can();
        this.Rest = new Rest();
        this.datauser = JSON.parse(localStorage.getItem("ls")) || [];
    }

    state = { ...this.initialState };


    handleChange = e => {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value
        }, () => {
            this.Rest.get('campanas/buscar/' + this.state.campaña, this.datauser)
                .then(resp => {
                    if (resp.status === 200 && resp.data.length > 0) {
                        this.setState({
                            error: false,
                            messageError: "",
                            camps: resp.data,
                            reportHidden: ""
                        })
                    }
                    else {
                        if (resp.status === 404) {
                            localStorage.removeItem('ls');
                            window.location = window.location.origin;
                        }
                        else {
                            this.setState({
                                error: false,
                                messageError: "No se encontraron resultados con el nombre buscado."
                            })
                        }
                    }
                })
                .catch(err => {
                    this.setState({
                        error: false,
                        messageError: "No se encontraron resultados con el nombre buscado."
                    })
                })
        })
    }


    componentDidMount() {
        this.obtenerCampañas();
    }

    obtenerCampañas = async () => {
        this.Rest.get("campanas", this.datauser)
            .then(campañas => {
                if (campañas.status === 200) {
                    this.setState({
                        camps: campañas.data
                    })
                }
                else {
                    if (campañas.status === 404) {
                        localStorage.removeItem('ls');
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: campañas.message
                        })
                    }
                }
            })
            .catch(err => {
                this.setState({
                    error: true,
                    messageError: "Error de respuesta del servidor"
                })
            })
    }

    verReporte(idcamp) {
        this.props.history.push("/reportes/campañas/" + idcamp);
    }





    render() {
        const { reportHidden, camps, error, errorMessage, reporte } = this.state;
        return (
            <Fragment>
                <div className="wrapper">
                    <Sidebar logout={() => this.props.callBackLogout()} />
                    <div id="content">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="dashboard-panel">
                                        <h4 className="mb-center">Reporte de campañas</h4>
                                        <Fragment>
                                            <label>Buscar campañas por nombre</label>
                                            <input type="text"
                                                className="form-control"
                                                onKeyUp={this.handleChange}
                                                name="campaña"
                                                id="campaña" autoComplete="off" />
                                        </Fragment>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div className="container mt-3">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="dashboard-panel">
                                        <h4 className="mb-center">Resultados de búsqueda para {this.state.campaña}</h4>
                                        <table className="table table-sm">
                                            <thead>
                                                <tr>
                                                    <th>Campaña</th>
                                                    <th>Usuario</th>
                                                    <th>Inicia</th>
                                                    <th>Finaliza</th>
                                                    <th>Mensaje</th>
                                                    <th>Estatus</th>
                                                    <th>Respuesta</th>
                                                    <th>Fecha de envío</th>
                                                    <th>Fecha de error</th>
                                                    <th>Reporte</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {camps ? camps.map((val, i) => (
                                                    <tr key={i}>
                                                        <td>{val.nombre}</td>
                                                        <td>{val.creador}</td>
                                                        <td>{val.fechaInicio} {val.horaInicio}</td>
                                                        <td>{val.fechaFinalizacion} {val.horaFinalizacion}</td>
                                                        <td>{val.mensaje}</td>
                                                        <td>
                                                            {val.habilitarCamp === "1" ?
                                                                <span className="badge badge-success">Activa</span>
                                                                : <span className="badge badge-danger">Inactiva</span>
                                                            }
                                                        </td>
                                                        <td>
                                                            {val.habilitarResp === "1" ?
                                                                <span className="badge badge-success">Resp. habilitada</span>
                                                                : <span className="badge badge-danger">Resp. inhabilitada</span>
                                                            }
                                                        </td>
                                                        <td>{val.fechaEnvio}</td>
                                                        <td>{val.fechaError}</td>
                                                        <td>
                                                            <button
                                                                onClick={() => this.verReporte(val.id_camp)}
                                                                className="btn btn-primary btn-sm">Ver Reporte
                                                        </button>
                                                        </td>
                                                    </tr>
                                                )) :
                                                    <tr>
                                                        <td colSpan="10">
                                                            <div className="alert alert-warning">No se encontraron campañas con el nombre buscado.</div>
                                                        </td>
                                                    </tr>}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>




                    </div>
                </div>



            </Fragment>
        );
    }
}

export default withRouter(CampaingBalance);


// WEBPACK FOOTER //
// ./src/components/campaigns/CampaignBalance.js